function getSelectedText() {
    let text = "";
    if (typeof window.getSelection != "undefined") {
        text = window.getSelection().toString();
    } else if (typeof document.selection != "undefined" && document.selection.type == "Text") {
        text = document.selection.createRange().text;
    }
    return text;
}

function deselectedText() {
    if (window.getSelection) {
        window.getSelection().removeAllRanges();
    } else if (document.selection) {
        document.selection.empty();
    }
}

// listener CTRL + ENTER 
document.addEventListener('keydown', function(event) {
    if (event.ctrlKey && event.code === "Enter") {
      let selectedText = getSelectedText();
      // check selected text
      if (selectedText) {
          openModalSendError(selectedText);
      }
    }
  });


// show tooltip near selected text
let tooltipEl = document.getElementById('tooltip_mistake');
let sel = window.getSelection();
let rel1= document.createRange();
rel1.selectNode(document.getElementById('help_tooltip1'));
var rel2= document.createRange();
rel2.selectNode(document.getElementById('help_tooltip2'));
window.addEventListener('mouseup', function () {
    if (!sel.isCollapsed) {
        let r = sel.getRangeAt(0).getBoundingClientRect();
        let rb1 = rel1.getBoundingClientRect();
        let rb2 = rel2.getBoundingClientRect();
        tooltipEl.style.top = (r.bottom - rb2.top)*100/(rb1.top-rb2.top) + 'px'; //this will place tooltipEl below the selection
        tooltipEl.style.left = (r.left - rb2.left)*100/(rb1.left-rb2.left) + 'px'; //this will align the right edges together
        tooltipEl.style.display = 'block';
    }
});
window.addEventListener('mousedown', function () {
  tooltipEl.style.display = 'none';
});




// MODAL SEND ERROR
const modalSendErrorMsg = document.querySelector("#modalSendErrorMsg");
const closeModalSendError = document.querySelector(".close_modal_send_error");
const btnCancelSendError = document.querySelector(".modal_send_error_btn_cancel");
const btnOkSendError = document.querySelector(".modal_send_error_btn_ok");
const msgTextareaSendError = document.querySelector("#modal_send_error_msg");
const blockSendErrorForms = document.querySelector(".block_send_error_forms");
const blockSendErrorResponse = document.querySelector(".block_send_error_response");

// open modal 
function openModalSendError(selectedText) {
    lockScroll();
    deselectedText();
    document.querySelector(".modal_send_error_dedicated_text").innerText = selectedText;
    document.querySelector("#modal_send_error_comment").value = "";
    blockSendErrorResponse.style.display = "none";
    msgTextareaSendError.style.display = "none";
    blockSendErrorForms.style.display = "block";
    btnOkSendError.style.display = "block";
    modalSendErrorMsg.style.display = "block";
}

// close modal
closeModalSendError &&
closeModalSendError.addEventListener("click", function () {
    modalSendErrorMsg.style.display = "none";
    unlockScroll();
  });

btnCancelSendError &&
btnCancelSendError.addEventListener("click", function () {
  modalSendErrorMsg.style.display = "none";
  unlockScroll();
});

window.addEventListener("click", function (event) {
  if (event.target == modalSendErrorMsg) {
    modalSendErrorMsg.style.display = "none";
    unlockScroll();
  }
});
closeModalESC(modalSendErrorMsg);

btnOkSendError &&
btnOkSendError.addEventListener("click", function () {
  let dedicatedText = document.querySelector(".modal_send_error_dedicated_text").innerText;
  let userComment = document.querySelector("#modal_send_error_comment").value;
  if(userComment === "") {
    msgTextareaSendError.style.display = "block";
  } else {
    msgTextareaSendError.style.display = "none";
    requestSendErrorMsg(dedicatedText, userComment);
  }
});

// request confirm rent to own
function requestSendErrorMsg(dedicatedText, userComment) {
  const request = new XMLHttpRequest();
  const url = site_lang_correction;
  const params = "wrong_text=" + dedicatedText + "&user_suggestion =" + userComment + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {
          blockSendErrorResponse.innerText = response.message;
          blockSendErrorResponse.style.display = "block";
          blockSendErrorForms.style.display = "none";
          btnOkSendError.style.display = "none";
  
        }
        if (response.status === "error") {
          blockSendErrorResponse.innerText = response.message;
          blockSendErrorResponse.style.display = "block";
          blockSendErrorForms.style.display = "none";
          btnOkSendError.style.display = "none";
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
// END MODAL SEND ERROR